import { Controller } from 'stimulus';
import Cookies from 'js-cookie';

export default class PromoPopupController extends Controller {
  dismissTimer = null;

  connect() {
    let revealDelay = 3000;
    if (this.element.dataset.revealDelay) revealDelay = this.element.dataset.revealDelay;

    setTimeout(() => {
      this.element.classList.remove('is-hidden');

      if (this.element.dataset.dismissTimer) this.setAutoDismiss();
    }, revealDelay);

    window.addEventListener('hidePromoPopup', this.hide);
  }

  disconnect() {
    window.removeEventListener('hidePromoPopup', this.hide);
  }

  setAutoDismiss = () => {
    this.dismissTimer = setTimeout(() => {
      this.hide();
    }, parseInt(this.element.dataset.dismissTimer, 10));
  }

  close = () => {
    const npsAction = document.querySelector('[data-nps-action]');
    const cookieKey = npsAction ? npsAction.getAttribute('data-nps-action') : 'dismissed_promo_popup';
    this.element.classList.add('is-hidden');
    this.remove();

    Cookies.set(cookieKey, '1');
  }

  hide = () => {
    this.element.classList.add('fade-out');
    this.remove();
  }

  remove = () => {
    if (this.dismissTimer) clearTimeout(this.dismissTimer);

    setTimeout(() => {
      this.element.remove();
    }, 500);
  }
}
